
import { URLS } from '../constants'
import {
    GET_ALL_PLAN_GROUPS_BEGIN, GET_ALL_PLAN_GROUPS_SUCCESS, GET_ALL_PLAN_GROUPS_FAILURE,
    GET_PLAN_GROUP_BEGIN, GET_PLAN_GROUP_SUCCESS, GET_PLAN_GROUP_FAILURE,
    POST_PLAN_GROUP_BEGIN, POST_PLAN_GROUP_SUCCESS, POST_PLAN_GROUP_FAILURE,
    PUT_PLAN_GROUP_BEGIN, PUT_PLAN_GROUP_SUCCESS, PUT_PLAN_GROUP_FAILURE,
    DELETE_PLAN_GROUP_BEGIN, DELETE_PLAN_GROUP_SUCCESS, DELETE_PLAN_GROUP_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, dispatchFetchDelete } from './ActionUtil'

// Get All Plan Groups
const acGetAllPlanGroupsBegin = () => ({ type: GET_ALL_PLAN_GROUPS_BEGIN })
const acGetAllPlanGroupsSuccess = data => ({ type: GET_ALL_PLAN_GROUPS_SUCCESS, payload: data })
const acGetAllPlanGroupsFailure = err => ({ type: GET_ALL_PLAN_GROUPS_FAILURE, payload: err })

/**
 * @description Retrieves all plan groups.
 * 
 * @author Maria Eduarda Franke
 */

export const acGetAllPlanGroups = () => {
    return dispatchFetchGet(
        URLS.PLAN_GROUPS,
        acGetAllPlanGroupsBegin,
        acGetAllPlanGroupsSuccess,
        acGetAllPlanGroupsFailure
    )
}

// Get Plan Group
const acGetPlanGroupBegin = () => ({ type: GET_PLAN_GROUP_BEGIN })
const acGetPlanGroupSuccess = data => ({ type: GET_PLAN_GROUP_SUCCESS, payload: data })
const acGetPlanGroupFailure = err => ({ type: GET_PLAN_GROUP_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve a plan group.
 *
 * @author Maria Eduarda Franke
 */
export const acGetPlanGroup = planGroupId => {
    return dispatchFetchGet(
        `${URLS.PLAN_GROUPS}/${planGroupId}`,
        acGetPlanGroupBegin,
        acGetPlanGroupSuccess,
        acGetPlanGroupFailure
    )
}

// Post Plan Group
const acPostPlanGroupBegin = () => ({ type: POST_PLAN_GROUP_BEGIN })
const acPostPlanGroupSuccess = data => ({ type: POST_PLAN_GROUP_SUCCESS, payload: data })
const acPostPlanGroupFailure = err => ({ type: POST_PLAN_GROUP_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create a plan group.
 *
 * @author Maria Eduarda Franke
 */
export const acPostPlanGroup = planGroup => {
    return dispatchFetchPost(
        URLS.PLAN_GROUPS,
        { ...planGroup },
        acPostPlanGroupBegin,
        acPostPlanGroupSuccess,
        acPostPlanGroupFailure
    )
}

// Put Plan Group
const acPutPlanGroupBegin = () => ({ type: PUT_PLAN_GROUP_BEGIN })
const acPutPlanGroupSuccess = data => ({ type: PUT_PLAN_GROUP_SUCCESS, payload: data })
const acPutPlanGroupFailure = err => ({ type: PUT_PLAN_GROUP_FAILURE, payload: err })

/**
 * @description Dispatches a PUT request to update a plan group.
 *
 * @author Maria Eduarda Franke
 * @throws {Error} If the request fails.
 */
export const acPutPlanGroup = (planGroupId, planGroup) => {
    return dispatchFetchPut(
        `${URLS.PLAN_GROUPS}/${planGroupId}`,
        { ...planGroup },
        acPutPlanGroupBegin,
        acPutPlanGroupSuccess,
        acPutPlanGroupFailure
    )
}

// Delete Plan Group
const acDeletePlanGroupBegin = () => ({ type: DELETE_PLAN_GROUP_BEGIN })
const acDeletePlanGroupSuccess = data => ({ type: DELETE_PLAN_GROUP_SUCCESS, payload: data })
const acDeletePlanGroupFailure = err => ({ type: DELETE_PLAN_GROUP_FAILURE, payload: err })

/**
 * @description Dispatches a DELETE request to delete a plan group.
 *
 * @author Maria Eduarda Franke
 */
export const acDeletePlanGroup = planGroupId => {
    return dispatchFetchDelete(
        `${URLS.PLAN_GROUPS}/${planGroupId}`,
        acDeletePlanGroupBegin,
        acDeletePlanGroupSuccess,
        acDeletePlanGroupFailure
    )
}